/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form"

import Menu from '../../../../components/CustomerClub/Menu'

import compaignIcon from '../../../../assets/svg/Compaign.svg'

import { notify } from '../../../../components/Toast'

import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import DatePicker from '@taak/react-modern-calendar-datepicker'

import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'

import { get, deleteItem, put } from '../../../../services/http'

function index() {
  document.title = 'جزئیات کمپین'

  const navigate = useNavigate()
  const { id } = useParams()

  const { register, handleSubmit, reset } = useForm()

  const [selectedDay, setSelectedDay] = useState('')
  const [timePartCount, setTimePartCount] = useState(2)
  const [time, setTime] = useState('')
  const [type, setType] = useState('')
    // eslint-disable-next-line no-unused-vars
  const [timePart, setTimePart] = useState([{ id : 1 }])
  const [campaign, setCampaign] = useState()
  const [clickButton, setClickButton] = useState(false)

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const token = localStorage.getItem('token')

  const timeHandler = () => {
    setTimePartCount(timePartCount + 1)
    setTimePart(oldArray => [...oldArray, { id : timePartCount}])
  }

  useEffect(() => {
    get(`/api/admin/campaign/${id}?token=${token}`)
      .then(response => {
        setCampaign(response.data.data[0])

        setTime(response.data.data[0].time)
        setType(response.data.data[0].type)

        let defaultValues = {}
        defaultValues.name = response.data.data[0].name
        defaultValues.money = response.data.data[0].money
        defaultValues.description = response.data.data[0].description
        reset({ ...defaultValues })
      }).catch((error) => {
        if(error) {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        }
      })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()

    let count = 0
    const timesArray = []
    while(count < JSON.parse(campaign.steps).length) {
      const item =  {
        step: data['days' + count],
        des: data['time' + count]
      }
      timesArray.push(item)
      count++
    }

    if (selectedDay !== '') {
      put(`/api/admin/campaign/${id}?token=${token}`, {
        'name': data.name,
        'time': `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`,
        'type': data.type,
        'money': data.money,
        'steps': JSON.stringify(timesArray),
        'description': data.description
      }).then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/cc/campaigns')
        }, 2000)
      })
      .catch(error => {
        setClickButton(false)
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
    } else {
      notify('error', 'تاریخ مشخص نشده')
    }
  }

  const deleteHandler = () => {
    deleteItem(`/api/admin/campaign/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/cc/campaigns')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید کمپین مورد نظر حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={() => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <ToastContainer rtl />
      <Menu page={'campaigns'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={compaignIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                کمپین‌ها
              </div>
            </div>
            <div className="left">
            <button onClick={() => { 
                setCover(true)
                setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'> حذف کمپین</button>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * نوشتن جزئیات هر کمپین می تواند شما را در اجرای آن موفق تر و هدفمند تر کند.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات کمپین
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام کمپین * :</label>
                <input id='foodName' {...register("name", { required: true, minLength: 3 })} type='text' placeholder='مثلا کمپین بهاری' />
                <small id='foodNameAlert'>نام کمپین باید وارد شود</small>
              </div>
              <div className='column'>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>تاریخ اجرا ({time}) * :</label>
                <DatePicker
                  value={selectedDay}
                  onChange={setSelectedDay}
                  shouldHighlightWeekends
                  locale="fa" // add this
                />
                <small id='foodLeveleDetailsAlert'>تاریخ اجرا باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantName'>نوع کمپین ({type}) * :</label>
                <select id='categoryName' {...register("type", { required: true })}>
                  <option value="اینستاگرام">اینستاگرام</option>
                  <option value="sms">sms</option>
                  <option value="سایت">سایت</option>
                  <option value="تبلیغات محیطی">تبلیغات محیطی</option>
                  <option value="کمپین 360">کمپین 360</option>
                  <option value="اینفلوئنسر مارکتینگ">اینفلوئنسر مارکتینگ</option>
                </select>
                <small id='resturantNameAlert'>نوع کمپین باید انتخاب شود</small>
              </div>
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='foodName'>بودجه (تومان) * :</label>
                <input id='offCodePercent' {...register("money", { required: true, minLength: 1 })}  className='ltrdirection' type='text' placeholder='25000' />
                <small id='foodNameAlert'>بودجه کمپین باید وارد شود</small>
              </div>
              <div className='column'>
              </div>
            </div>
            <div className='lineTitleFood'>
              <hr />
              گام های کمپین
              <hr />
            </div>
            {campaign ? JSON.parse(campaign.steps).map((item, index) => (
              <div className='row' key={index}>
                <div className='column'>
                  <label htmlFor='resturantDay'>روز کاری مجموعه * :</label>
                  <input id='resturantDay' defaultValue={item.step} {...register(`days${index}`, { required: true, minLength: 3 })} type='text' placeholder='از شنبه تا چهارشنبه' />
                  <small id='resturantDayAlert'>روز کاری مجموعه باید وارد شود</small>
                </div>
                <div className='column'>
                  <label htmlFor='resturantTime'>ساعت کاری مجموعه * :</label>
                  <input id='resturantTime' defaultValue={item.des} {...register(`time${index}`, { required: true, minLength: 3 })} type='text' placeholder='از ساعت 11 تا 1 بامداد' />
                  <small id='resturantTimeAlert'>ساعت کاری مجموعه باید وارد شود</small>
                </div>
              </div>
            )) : ''}
            <div className="row" style={{ display: 'none' }}>
              <div className="add" onClick={timeHandler}>
                +
              </div>
            </div>
            <div className='lineTitleFood'>
              <hr />
              توضیحات کمپین
              <hr />
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='foodDetail'>توضیحات * :</label>
                <textarea id='foodDetail' rows={5} placeholder='توضیحات' {...register("description", { required: true })} />
                <small id='foodDetailAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'آپدیت کمپین'}</button>
          </form>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index